/* istanbul ignore file */

import { VideoWithDocId } from '@yoimo/client-sdk/videos';

function withProdPrefix(str: string): string {
  return 'https://md.p0.jar15.joymo.no/public/' + str;
}

function withBucsPrefix(str: string): string {
  return 'https://md.p0.bucs-jar15.joymo.tv/public/' + str;
}

/** HARDCODED PREROLLS **/
const TTEMBL_PREROLL = withProdPrefix(
  '03dxTiI8BLENlk1Vat4N/ads/MBLNatChamps.mp4'
);

const TTE_INSURA = withProdPrefix(
  'QaVzbVlrp8deh9ojYgtZ/ads/Insura+App+Sting+-+5S-encoded.mp4'
);

const ARCHERY_ONE_TO_RULE_THEM_ALL = withProdPrefix(
  'jcuiiq6fmjXY0kAEIfCo/ads/10DEC_ARCHERY_PRE_ROLL.mp4'
);

const ARCHERY_HOYT = withProdPrefix(
  'jcuiiq6fmjXY0kAEIfCo/ads/2024_Hoyt_Easton_+Combined.mp4'
);

const ARCHERY_AD24 = withProdPrefix(
  'jcuiiq6fmjXY0kAEIfCo/ads/Advert_24_Edit_1.mp4'
);

const ARCHERY_BEST_MONEY_CAN_BUY = withProdPrefix(
  'jcuiiq6fmjXY0kAEIfCo/ads/2024-Wa-10-Second-Commercial-Final.mp4'
);

const BI_PREROLL_2024 = withProdPrefix(
  'VzIFad2Sq29SnFONF1Mj/ads/IrelandRlogo.mp4'
);

const BI_PREROLL_Ot8nJE5CDLxR29eN9LpO = withProdPrefix(
  'VzIFad2Sq29SnFONF1Mj/ads/Ot8nJE5CDLxR29eN9LpO.mp4'
);
const BI_PREROLL_A1JlNol9I5phPo3H9HwB = withProdPrefix(
  'VzIFad2Sq29SnFONF1Mj/ads/A1JlNol9I5phPo3H9HwB.mp4'
);
const BI_PREROLL_WoVdweQtf4AfmLVM1kzZ = withProdPrefix(
  'VzIFad2Sq29SnFONF1Mj/ads/WoVdweQtf4AfmLVM1kzZ.mp4'
);
const BI_PREROLL_dRdFRrSuCvGqRWvnlltG = withProdPrefix(
  'VzIFad2Sq29SnFONF1Mj/ads/dRdFRrSuCvGqRWvnlltG.mp4'
);

const EN_PREROLL_2025 = withProdPrefix(
  '8qRfXG1IprJvJTK6HZNT/ads/EN-Super-Cup-Pre-Roll.mp4'
);
const USM_MANCHESTER_2024 = withBucsPrefix(
  'BpKUGfqLxV4qwupF10kd/ads/preroll-manchester-2024-09-25.mp4'
);

const _link = (l: string) => `https://l.linklyhq.com/l/${l}`;
export const hardCodedPrerolls = [
  //
  [
    'Ot8nJE5CDLxR29eN9LpO',
    {
      url: BI_PREROLL_Ot8nJE5CDLxR29eN9LpO,
      href: 'https://2ly.link/24WzT',
    },
  ],
  [
    'A1JlNol9I5phPo3H9HwB',
    {
      url: BI_PREROLL_A1JlNol9I5phPo3H9HwB,
      href: 'https://2ly.link/24WzW',
    },
  ],
  [
    'WoVdweQtf4AfmLVM1kzZ',
    {
      url: BI_PREROLL_WoVdweQtf4AfmLVM1kzZ,
      href: 'https://2ly.link/24WzY',
    },
  ],
  [
    'dRdFRrSuCvGqRWvnlltG',
    {
      url: BI_PREROLL_dRdFRrSuCvGqRWvnlltG,
      href: 'https://2ly.link/24Wzc',
    },
  ],
  // TTE event
  [
    'buv5OKD0rE6q5TO3I1fc',
    {
      url: TTEMBL_PREROLL,
      href: '',
      tags: ['Qualifiers'],
    },
  ],
  // Testing event
  [
    'SOME-RANDOM-TESTING-EVENT-ID',
    {
      url: '',
      href: 'https://no.where/',
    },
  ],
  [null, null],
] as const;

export function getPreroll(video: VideoWithDocId) {
  if (video.eventId === 'buv5OKD0rE6q5TO3I1fc') {
    return {
      url: TTE_INSURA,
      href: 'https://2ly.link/1x2MJ',
    };
  }
  if (video.channelId === 'jcuiiq6fmjXY0kAEIfCo') {
    switch (video.eventId) {
      case 'a5blAhnSpUmXAKXyK0hD':
        return {
          url: ARCHERY_AD24,
          href: 'https://bit.ly/3vLGyQn',
        };
      case '3rJVr8eAR2ZXTbJpPMCo':
        return {
          url: ARCHERY_HOYT,
          href: 'https://bit.ly/4cJSClV',
        };
      case 'CBZfm3t2eB1xs2kLBkB0':
        return {
          url: ARCHERY_BEST_MONEY_CAN_BUY,
          href: 'https://2ly.link/1y8p1',
        };
      default:
        return {
          url: ARCHERY_ONE_TO_RULE_THEM_ALL,
          href: '',
        };
    }
    return null;
  }

  if (video.channelId === '8qRfXG1IprJvJTK6HZNT') {
    return {
      url: EN_PREROLL_2025,
      href: 'https://tinyurl.com/47r66ay8',
    };
  }
  // University of manchester
  if (video.channelId === 'BpKUGfqLxV4qwupF10kd') {
    return {
      url: USM_MANCHESTER_2024,
      href: 'https://bit.ly/3XGm59M',
    };
  }

  const preroll = hardCodedPrerolls.find((entry) => {
    if (video.eventId !== entry[0] || !entry[1]) {
      return null;
    }
    if (!('tags' in entry[1])) {
      return entry[1];
    }
    if (entry[1].tags.some((t) => video.tags.includes(t))) {
      return entry[1];
    }
    return null;
  });
  if (preroll) return preroll[1];

  if (video.channelId === '0AYlDfFb7OtdRQfjgbQ2') {
    return {
      url: BI_PREROLL_2024,
      href: 'https://2ly.link/1zZGa',
    };
  }

  return null;
}
